import styled from 'styled-components';
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-1xkzzp2-0"
})(["", ""], function (_ref) {
  var bottomMargin = _ref.bottomMargin;
  return bottomMargin ? 'margin-bottom: 52px;' : '';
});